import { Box, CardMedia, Icon, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import defaultImage from 'assets/images/default_avatar.png'
import AdxButton from 'components/custom/AdxButton'

const PActiveEvalList = ({ evaluations, status }) => {
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  const appraisalId = pathname.split('/').pop()

  const handleStart = (submissionId, evaluationDetails, revieweeDetails) => {
    navigate(`/app/performance/appraisal/evaluation/${submissionId}`, {
      state: {
        ...state,
        evaluationDetails,
        revieweeDetails,
        appraisalId: appraisalId,
        initialTabsValue: 1,
      },
    })
  }

  const handleView = (submissionId, evaluationDetails, revieweeDetails) => {
    navigate(`/app/performance/appraisal/view-result/${submissionId}`, {
      state: {
        ...state,
        evaluationDetails,
        revieweeDetails,
        appraisalId: appraisalId,
        initialTabsValue: 1,
      },
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.3,
        borderRadius: '10px',
        overflow: 'hidden',
        marginBottom: 10,
      }}
    >
      {evaluations?.map((e, index) => {
        let reviewees = []

        if (e?.is_external === 0) {
          reviewees.push(
            ...e?.evaluation_detail?.filter((detail) => detail?.roles?.includes('reviewer'))
          )
        }

        if (reviewees.length !== 0) {
          return (
            e?.is_external === 0 && (
              <Box key={index} display="flex" flexDirection="column">
                <Box
                  bgcolor="white.main"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  py={2.5}
                  px={3}
                >
                  <Box display="flex" alignItems="center" gap={3}>
                    <Typography fontWeight="bold" color="dark-text.main">
                      {e?.evaluation_title}
                    </Typography>
                  </Box>
                  {reviewees?.length === 1 ? (
                    <Box display="flex" alignItems="center" gap={4}>
                      {!reviewees[0]?.submitted ? (
                        <AdxButton
                          variant={'contained'}
                          onClick={() => handleStart(reviewees[0]?.submission_id, e, reviewees[0])}
                          sx={{ width: 120 }}
                          size="small"
                          disabled={status === 'Completed' ? true : false}
                        >
                          Start
                        </AdxButton>
                      ) : (
                        <Box display="flex" gap={3}>
                          <Box display="flex" gap={1} alignItems="center">
                            <Icon sx={{ fontSize: 16, color: 'positive.main' }}>check_circle</Icon>
                            <Typography color="light-gray-text.main">Completed</Typography>
                          </Box>
                          <Typography
                            color="alternate.main"
                            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleView(reviewees[0]?.submission_id, e, reviewees[0])}
                          >
                            View
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Typography
                      sx={{ width: 120, textAlign: 'right' }}
                      color="light-gray-text.main"
                    >
                      {reviewees?.length} reviewee(s)
                    </Typography>
                  )}
                </Box>

                {/* List of form for more than 1 reviewees  */}
                {reviewees?.length > 1 && (
                  <Box display="flex" flexDirection="column" bgcolor="white.main" px={3}>
                    {reviewees?.map((r, index) => (
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2.5}
                        key={index}
                      >
                        <Box display="flex" alignItems="center" gap={3}>
                          <CardMedia
                            component="img"
                            sx={{
                              height: 45,
                              width: 45,
                              objectFit: 'cover',
                              borderRadius: '50%',
                            }}
                            src={r?.reviewee_image || defaultImage}
                          />
                          <Box display="flex" flexDirection="column">
                            <Typography>{r?.reviewee_name ?? 'Reviewee ' + (index + 1)}</Typography>
                            <Typography variant="body2" color="light-gray-text.main">
                              {r?.reviewee_department_name}
                            </Typography>
                          </Box>
                        </Box>
                        {!r?.submitted ? (
                          <AdxButton
                            variant={'contained'}
                            key={index}
                            sx={{ width: 120 }}
                            size="small"
                            onClick={() => handleStart(r?.submission_id, e, r)}
                            disabled={status === 'Completed' ? true : false}
                          >
                            Start
                          </AdxButton>
                        ) : (
                          <Box display="flex" gap={3}>
                            {status === 'Active' && (
                              <Box display="flex" gap={1} alignItems="center">
                                <Icon sx={{ fontSize: 16, color: 'positive.main' }}>
                                  check_circle
                                </Icon>
                                <Typography color="light-gray-text.main">Completed</Typography>
                              </Box>
                            )}
                            <Typography
                              color="alternate.main"
                              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                              onClick={() => handleView(r.submission_id, e, r)}
                            >
                              View
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )
          )
        }
      })}
    </Box>
  )
}

export default PActiveEvalList
